<main class="body-main">
  <div class="upload-document-sec">
    <div class="upload-document-sec-header">
      <div class="logo">Syncinns</div>
      <button class="logout-btn" (click)="logout()">Log Out</button>
    </div>
    <div class="upload-document-box">
      <h2>Upload Your Documents</h2>

<div *ngFor="let doc of requiredDocuments" class="upload-section">
  <div class="doc-info">
    <div class="doc-title">{{ doc.doc_name | titlecase }} upload</div>
    <div class="doc-subtitle" >
      {{ doc.file_name ||  'Please upload this document (PDF or image, max 5 MB).' }}
    </div>
  </div>
  <div>
    <!-- <input
      type="file"
      [id]="'file-upload-' + doc.doc_id"
      style="display: none"
      (change)="onFileSelected($event, doc.doc_id)"
    /> -->
    <input
  type="file"
  #fileInput
  style="display: none"
 accept=".pdf,.jpg,.jpeg,.png"
  (change)="onFileSelected($event, doc.doc_id)"
/>

@if (doc.is_uploaded) {
<button class="submitted-btn" >
 Submitted
</button>
}@else{
<button class="upload-btn" (click)="fileInput.click()">
  Upload
</button>
}
  </div>
</div>

     
    </div>
   <!-- <div class="input-comment">
  <label for="docComment" class="input-label">Register Address</label>
  <input type="text" id="docComment" class="form-control comment-input" [(ngModel)]="registered_address" placeholder="Enter your register address"  googlePlacesAutocomplete
                        (placeChanged)="onPlaceSelected($event)">
</div> -->
<!-- 
<div class="button-group d-flex justify-content-end">
  <button class="close-btn" (click)="onCloseUploadDocs()">Close</button>
  <button class="close-btn" (click)="uploadAllDocuments()">Submit</button>
</div> -->

  </div>
</main>